export const dimensions = {
  '2xsmall': '16px',
  xsmall: '20px',
  small: '24px',
  medium: '32px',
  large: '40px',
  xlarge: '56px',
} as const;

/**
 * Extends the `dimensions` definition with additional properties used to
 * build the Tailwind theme and `cn()` merge utility.
 */
// NOTE: the `dimensions` object should only contain t-shirt sizes, so its keys can be
// used for e.g. component prop types, etc.
export const tailwindDimensions = {
  ...dimensions,
  minTouchTarget: '44px',
} as const;

export type DimensionKey = keyof typeof dimensions;
